import slugify from "slugify";
import geolocationInstructionsModal from "./geolocation-instructions-modal";
import { FavoriteStorage, SearchedStorage } from "./local-storage-functions";

function buildCityMeta(place) {
  const name = place.cname;
  const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
  const label = `${name} - ${uf}`;
  const slug = slugify(String(name)).replaceAll("-", "").toLowerCase();
  const href = `/previsao-do-tempo/cidade/${place.cid}/${slug}-${uf.toLowerCase()}`;
  return { name, uf, label, href };
}

function padIndex(position) {
  const numeric = Number(position) || 0;
  return numeric.toString().padStart(2, '0');
}

function createListItem({ label, href }, position, idSufix) {
  const li = document.createElement('li');
  li.className = 'favorites-list-item';

  const a = document.createElement('a');
  a.href = href;
  a.textContent = label;
  const formattedIndex = padIndex(position);
  a.id = `Modal_Locations_Item_${idSufix}-${formattedIndex}`
  a.dataset.id = `Modal_Locations_Item_${idSufix}-${formattedIndex}`

  li.append(a);
  return li;
}

const getIsLocationGranted = async () => {
  const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

  return permissionStatus.state === "granted";
}

const renderDisabledLocationModal = async () => {
  const isLocationGranted = await getIsLocationGranted();

  if (isLocationGranted) return

  const storedFavorites = FavoriteStorage.get()
  const storedRecents = SearchedStorage.get()

  if (storedFavorites?.length) {
    $("#locations-modal-menu-favorite-locations").empty();

    storedFavorites.slice(0, 4).forEach((favorite, index) => {
      const city = buildCityMeta(favorite.city);
      const li = createListItem(city, index + 1, "FavoriteLink")

      $("#locations-modal-menu-favorite-locations").append(li);
    });
  }

  if (storedRecents?.length) {
    $("#locations-modal-menu-recent-locations").empty();

    storedRecents.slice(0, 4).forEach((recent, index) => {
      const city = buildCityMeta(recent.city);
      const li = createListItem(city, index + 1, "RecentLink")

      $("#locations-modal-menu-recent-locations").append(li);
    });
  }
}

const handleMyLocationButton = () => {
  window.dataLayer = window.dataLayer || [];

  $("#locations-modal-menu-use-my-location-button").on("click", () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        $("#locations-modal-menu-use-my-location-button").empty()
        $("#locations-modal-menu-use-my-location-button").attr("disabled", "true")
        $("#locations-modal-menu-use-my-location-button").append('<div class="loading"></div>')

        $.ajax({
          type: 'POST',
          url: "/json/minha-localizacao",
          data: {
            latitude: latitude.toFixed(5),
            longitude: longitude.toFixed(5)
          },
          dataType: 'json',
          success: (json) => {
            const { idcity, city, uf } = json.data[0]

            const href = `/previsao-do-tempo/cidade/${idcity}/${slugify(city).replaceAll("-", "").toLowerCase()}-${uf.toLowerCase()}`
            window.location.href = href

            window.dataLayer.push({
              event: 'click_button',
              id: 'Modal_Locations_Button_UseLocation',
              button_action: href,
            })
          }
        })
      },
      () => {
        $('#locations-modal').addClass('hidden')

        window.dataLayer.push({
          event: 'click_button',
          id: 'Modal_Locations_Button_UseLocation',
        })

        geolocationInstructionsModal.open();
      },
      {
        enableHighAccuracy: true,
        maximumAge: 3000,
      }
    )
  })
}

const handleOutsideModalClick = () => {
  $("#locations-modal-outside-button").on("click", (e) => {
    $('#locations-modal').addClass('hidden');

    window.dataLayer.push({
      event: 'close_element',
      id: 'Modal_Locations'
    })
  });
}

const open = () => {
  $('#locations-modal').removeClass('hidden')

  window.dataLayer.push({
    event: 'open_element',
    id: 'Modal_Locations'
  })
}

const init = () => {
  renderDisabledLocationModal();
  handleMyLocationButton();
  handleOutsideModalClick();
}

const locationsModal = {
  init,
  open,
}

export default locationsModal
